import type { LayoutFields } from './types.tsx';

export const STATUS_PAGES_CF_TYPE: NonNullable<LayoutFields['STATUS_PAGES_CF_TYPE']> =
	'com.atlassian.jira.modules.servicemanagement.status-pages-entity:status-pages-entity-field-cftype';
